<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <button-export
        :href="exportUrl"
        download="download.xls"
        value="导出"/>
      <div class="btn-box">
        <input-select selectTitle="报警类型" :selectKey="'alarmType'" :selectData="alarmTypeList" @search="search"/>
      </div>
      <input-search placeholder="设备名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/ParkingService'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'call-police',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧停车',
          name: 'parking-device-management'
        }, {
          value: '报警记录'
        }],
        addController: 'controller-add',
        exportUrl: '',
        alarmTypeList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '1',
            label: '防拆报警'
          }, {
            key: '2',
            label: '尾随报警'
          }
        ],
        tableHead: [{
          prop: 'deviceName',
          label: '设备名称'
        }, {
          prop: 'alarmTypeText',
          label: '报警类型'
        }, {
          prop: 'alarmTime',
          label: '报警时间'
        }, {
          prop: 'responsiblePersonName',
          label: '责任人'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          alarmType: ''
        }
      }
    },
    created () {
      // this.permissionCodes = bus.global.permissionCodes
      this.exportUrl = `${api.exportParkingAlarmRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
      this.getPage()
    },
    methods: {
      // 获取报警记录
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getParkingAlarmRecord, reqData)
          .then(res => {
            let data = res.data.data.list
            data.map(v => {
              if (v.alarmType === '1') {
                v.alarmTypeText = '防拆报警'
              } else if (v.alarmType === '2') {
                v.alarmTypeText = '尾随报警'
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          })
          .catch(errorHandler('获取报警记录失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/CallPolice/CallPolice.vue